import React from 'react';
import './List.less';
import clsx from 'clsx';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function List({ children, className }: Props) {
  return <ul className={clsx('base-list', className)}>{children}</ul>;
}
